/**
 * 換算設定のバリデーションのエラーメッセージ。
 * サーバーと同じ文言にする（backend/core/src/services/credit_conversion_settings/validation.rs）。
 */

export const messages = {
  dateBlank: '適用開始日を入力してください。',
  dateFormat: '適用開始日はYYYY-MM-DDの形式の日付で入力してください。',
  dateNotAfterToday: (today: string) => `適用開始日は、当日（${today}）より後の日にしてください。`,
  numberBlank: '値を入力してください。',
  numberFormat:
    '半角の数字と小数点で入力してください（例：150、0.04048）。桁区切りのカンマ、先頭の余分な0、符号、指数表記は使えません。',
  noRows: '行を1つ以上追加してください。',
  duplicateLowerBound:
    '下限が同じ行がほかにあります。下限を変えるか、どちらかの行を削除してください。',
  duplicateConsumptionItem:
    '消費項目が同じ行がほかにあります。キャンセルして、もう一度やり直してください。',
  noZeroStep: '下限が0の段階がありません。下限を0にした行を追加してください。',
} as const;
